if(!Object.fromEntries) {
  Object.fromEntries = entries => {
    const obj = {};
    entries.forEach((val, key) => obj[key] = val);
    return obj;
  };
}